module.exports = __webpack_public_path__ + "img/mai.efb9c1ca.png";